export default [
    { key: 'name', label: 'Nombre' },
    { key: 'document', label: 'Documento' },
    { key: 'instructions', label: 'Instrucciones' },
    { key: 'registered_by.name', label: 'Registrado por' },
    { key: 'client.name', label: 'Cliente' },
    { key: 'photo', label: 'Foto' },
    { key: 'actions', label: '' },
]